import { render, staticRenderFns } from "./Animation.vue?vue&type=template&id=8d8be80e&scoped=true"
import script from "./Animation.vue?vue&type=script&lang=js"
export * from "./Animation.vue?vue&type=script&lang=js"
import style0 from "./Animation.vue?vue&type=style&index=0&id=8d8be80e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8be80e",
  null
  
)

export default component.exports